import { env } from "../env";

const TAG_ID = "2614375882598";

const PINTEREST_SNIPPET = `!function(e){if(!window.pintrk){window.pintrk = function () {
window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
  n=window.pintrk;n.queue=[],n.version="3.0";var
  t=document.createElement("script");t.async=!0,t.src=e;var
  r=document.getElementsByTagName("script")[0];
  r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
pintrk('load', '${TAG_ID}');
pintrk('page');`;

let initialized = false;

export function initPinterest() {
  if (initialized) {
    return;
  }

  if (env.VITE_VERCEL_ENV !== "production") {
    return;
  }

  if (typeof window === "undefined") {
    return;
  }

  if ((window as Window & { pintrk?: unknown }).pintrk) {
    initialized = true;
    return;
  }

  const script = document.createElement("script");
  script.textContent = PINTEREST_SNIPPET;
  document.head.append(script);

  initialized = true;
}
